import {
  Button,
  Container,
  Dropdown,
  DropdownButton,
  Spinner,
} from "react-bootstrap";
import { useEffect, useState } from "react";
import { intervalToDuration, formatDistanceStrict } from "date-fns";

import ScreenHeader from "../../../../../components/ScreenHeader/ScreenHeader";
import EntryScorecard from "../../EntryScorecard/EntryScorecard";
import EntryProfile from "./EntryProfile";
import useScorecardScreen from "./useScorecardScreen";
import { ApiCompetition } from "../../../../../types";

const useNow = () => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date());
    }, 500);
    return () => clearInterval(interval);
  });
  return now;
};

const EndTimeDisplay = ({ competition }: { competition?: ApiCompetition }) => {
  const endTime = competition?.endTime;
  const now = useNow();
  if (endTime && now > new Date(endTime)) {
    return null;
  }
  if (!endTime) {
    return null;
  }

  const dt = new Date(endTime).getTime() - now.getTime();
  let timeDisplay;

  if (dt < 1000 * 60 * 60 * 6) {
    const duration = intervalToDuration({ start: 0, end: dt });
    timeDisplay = [duration.hours, duration.minutes, duration.seconds]
      .map((x) => String(x || 0).padStart(2, "0"))
      .join(":");
  } else {
    timeDisplay = formatDistanceStrict(new Date(endTime), now);
  }
  return (
    <div
      className="d-flex align-items-baseline justify-content-center bg-primary text-white py-1"
      style={{
        marginLeft: -12,
        marginRight: -12,
        marginTop: -12,
      }}
    >
      <div className="fs-6 me-2 text-opacity-75">Time left:</div>
      <div className="fs-6 fw-bold">{timeDisplay}</div>
    </div>
  );
};

export default function ScorecardScreen() {
  const {
    entry,
    entryRoutes,
    entryLoading,
    availableEntries,
    selectEntry,
    reload,
    competition,
    onAddCompetitorNumber,
    canViewLeaderboard,
    navigateToLeaderboard,
  } = useScorecardScreen();

  return (
    <Container>
      <ScreenHeader canGoBack={false}>Scorecard</ScreenHeader>
      <EndTimeDisplay competition={competition} />
      <div
        className="d-flex justify-content-between align-items-center p-2"
        style={{
          marginLeft: -12,
          marginRight: -12,
        }}
      >
        <EntryProfile entry={entry} />
        {availableEntries.length > 1 ? (
          <DropdownButton title="Competitors" size="sm">
            {availableEntries?.map((availableEntry) => (
              <Dropdown.Item
                key={availableEntry.user.uuid}
                onClick={() => selectEntry(availableEntry.user.uuid)}
              >
                {availableEntry.user.firstName} {availableEntry.user.lastName}
              </Dropdown.Item>
            ))}
            {competition?.settings.hasPreloadedEntries ? (
              <Dropdown.Item onClick={onAddCompetitorNumber}>
                Add more...
              </Dropdown.Item>
            ) : null}
          </DropdownButton>
        ) : competition?.settings.hasPreloadedEntries ? (
          <Button size="sm" onClick={onAddCompetitorNumber}>
            Add&nbsp;competitor
          </Button>
        ) : null}
      </div>
      {entry && entryRoutes && availableEntries ? (
        <>
          <EntryScorecard entry={entry} routes={entryRoutes} />
        </>
      ) : (
        <div className="align-center">
          <Spinner animation="border" />
        </div>
      )}
      <div className="my-2 text-center">
        <Button onClick={() => reload()} disabled={entryLoading}>
          {entryLoading ? <Spinner size="sm" animation="border" /> : null}{" "}
          Refresh
        </Button>{" "}
        {canViewLeaderboard ? (
          <Button
            variant="outline-primary"
            onClick={() => navigateToLeaderboard()}
          >
            View Leaderboard
          </Button>
        ) : null}
      </div>
    </Container>
  );
}
